<template>
  <div class="MemberMessage">
    <el-tabs class="el-tabs-common" v-model="current">
      <el-tab-pane
        v-for="(item, index) in types"
        :key="index"
        :name="item.type"
        :label="item.label + item.not_read_show"
      ></el-tab-pane>
    </el-tabs>
    <ul class="tab-content message" v-if="list.length">
      <li
        class="item"
        :class="{
          hover:
            item.is_read != 1 ||
            item.template_id == 'oto_pay_success' ||
            item.template_id == 'oto_before_start' ||
            item.template_id == 'oto_connect_new_msg' ||
            item.template_id == 'live_open_course',
        }"
        v-for="item in list"
        :key="item.id"
      >
        <div class="left">
          <div class="title-wrap">
            <img
              class="icon"
              src="../../images/member/message-course@2x.png"
              v-if="item.message_classify == 'course'"
            />
            <img
              class="icon"
              src="../../images/member/message-oto@2x.png"
              v-else-if="item.message_classify == 'oto'"
            />
            <img
              class="icon"
              src="../../images/member/message-order@2x.png"
              v-else-if="item.message_classify == 'order'"
            />
            <img
              class="icon"
              src="../../images/member/message-system@2x.png"
              v-else-if="item.message_classify == 'system'"
            />
            <img
              class="icon"
              src="../../images/member/message-exam@3x.png"
              v-else-if="item.message_classify == 'exam'"
            />
            <img
              class="icon"
              src="../../images/member/message-schedule@2x.png"
              v-else-if="item.message_classify == 'contractSchedule'"
            />
            <img
              class="icon"
              src="../../images/member/message-course-period-report@2x.png"
              v-else-if="item.message_classify == 'coursePeriodReport'"
            />
            <span :class="['title', { noRead: item.is_read !== 1 }]" class="title">{{
              item.title
            }}</span>
          </div>
          <v-clamp class="content" autoresize :max-lines="2" :expanded.sync="item.expanded">
            <template>{{ item.content }}</template>
            <template v-slot:after="{ clamped, expanded }">
              <a
                class="content-expand"
                v-if="clamped || expanded"
                @click="item.expanded = !item.expanded"
              >
                <span>{{ expanded ? '收起' : '展开' }}</span>
                <img v-if="!expanded" src="@/assets/images/message/expand@2x.png" />
                <img v-else src="@/assets/images/message/collapse@2x.png" />
              </a>
            </template>
          </v-clamp>
          <div class="link-wrap" v-if="item.message_link_title">
            <img src="@/assets/images/message/link@2x.png" />
            <a @click="onLinkClick(item)">{{ item.message_link_title }}</a>
          </div>
          <div class="created-time">
            {{ item.created_at | tsFormat('yyyy/MM/dd hh:mm:ss') }}
          </div>
        </div>
        <el-button class="right" @click="messageClick(item)" size="medium" style="width: 100px"
          >立即查看</el-button
        >
      </li>
    </ul>
    <EmptyNew v-else title="暂无消息"></EmptyNew>
    <el-pagination
      v-if="total > 10"
      class="center pager"
      background
      layout="prev, pager, next"
      :total="total"
      @current-change="changePage"
    ></el-pagination>
    <div class="read-wrap" @click="setRead">
      <img src="@/assets/images/message/read@2x.png" />
      <span>全部已读</span>
    </div>
  </div>
</template>
<script>
import VClamp from 'vue-clamp';
import EmptyNew from '@/components/EmptyNew.vue';
import { triggerLoaded } from '@/components/LoadContainer.vue';

export default {
  name: 'MemberMessage',
  components: { VClamp, EmptyNew },
  data() {
    return {
      current: 'all',
      list: [],
      limit: 10,
      page: 1,
      total: 0,
    };
  },
  computed: {
    commonSetting() {
      return this.$store.state.commonSetting;
    },
    types() {
      let types = [
        {
          type: 'all',
          label: '全部',
        },
        {
          type: 'course',
          label: '课程',
        },
      ];
      if (this.commonSetting.switch_contract_schedule == 1) {
        types.push({
          type: 'contractSchedule',
          label: '排课',
        });
      }
      types.push({
        type: 'order',
        label: '订单',
      });
      if (this.commonSetting.switch_oto_module == 1) {
        types.push({
          type: 'oto',
          label: '约课',
        });
      }
      types.push({
        type: 'system',
        label: '系统',
      });
      types.push({
        type: 'coursePeriodReport',
        label: '报告',
      });
      types.forEach((t) => {
        if (this.$store.state.message[t.type] && this.$store.state.message[t.type].not_read > 0) {
          t.not_read_show = `(${this.$store.state.message[t.type].not_read_show})`;
        } else {
          t.not_read_show = '';
        }
      });
      return types;
    },
  },
  watch: {
    async current() {
      this.page = 1;
      await this.getData();
    },
  },
  async created() {
    await this.getData();
    triggerLoaded(this);
  },
  methods: {
    async getData() {
      let data = await this.$http.post('/api/app/message/getMessage', {
        message_classify: this.current,
        limit: this.limit,
        page: this.page,
      });
      data.list.forEach((m) => {
        m.content +=
          m.link_type == 1 && parseInt(m.created_at) * 1000 + 30 * 60 * 1000 > new Date().getTime()
            ? '<a>立即支付</a>'
            : '';
        m.expanded = false;
      });
      this.list = data.list;
      this.total = data.total;
    },
    async changePage(page) {
      this.page = page;
      await this.getData();
    },
    async messageClick(item) {
      if (item.is_read != 1) {
        await this.$http.put('/api/app/message/mark/read/' + item.id);
        this.$store.commit('setMessageRead', { type: item.message_classify });
        item.is_read = 1;
      }
      if (item.template_id == 'oto_pay_success' || item.template_id == 'oto_before_start') {
        this.$router.push({
          name: 'MemberOto',
        });
      } else if (item.template_id == 'oto_connect_new_msg') {
        this.$router.push({
          name: 'MemberOtoCommunication',
          query: {
            id: item.course_id,
            teacher_id: item.teacher_id,
            from: 1,
          },
        });
      } else if (item.template_id == 'oto_open_next_week') {
        this.$router.push({
          name: 'Oto',
        });
      } else if (item.template_id == 'live_open_course') {
        this.$router.push({
          name: 'MemberStudy',
          query: {
            id: item.course_id,
          },
        });
      } else if (item.template_id == 'coursePeriodReport') {
        this.$webSeeSendTrack({
          event_id: 'message-study-report_click',
          event_type: 'click',
          data: {
            course_id: item.course_id, // 课程id
            period_id: item.period_id, // 课节id
            status: item.status, // 0 未生成 1 未查看 2 已查看
            short_link_code: item.short_link_code, // 报告码
          },
        });

        window.open(`/h5/study_report?id=${item.short_link_code}`, '_blank');
      } else if (item.link_type == 1) {
        let order = await this.$http.post('/api/app/myOrder/detail', {
          order_id: item.order_id,
        });
        if (order.order_status == 2) {
          await this.$info('该订单交易已完成');
        } else if (order.order_status == 3) {
          await this.$info('该订单交易已关闭');
        } else if (order.pay_status == 1) {
          this.$router.push({
            name: 'OrderPay',
            params: {
              id: item.order_id,
            },
            query: {
              type: item.shop_type,
            },
          });
        }
      } else {
        await this.$info('请在本页列表中查看');
      }
    },
    async onLinkClick(item) {
      if (item.message_link_type == 1) {
        let schoolId = item.message_link_school_id;
        if (schoolId) {
          this.$store.commit('setSchoolID', schoolId);
        }
        let { href } = this.$router.resolve({
          name: 'CourseShow',
          params: {
            id: item.message_link_content,
          },
          query: {
            school_id: schoolId,
          },
        });
        window.location = href;
      } else if (item.message_link_type == 2) {
        this.$router.push({
          name: 'GoodsDetail',
          params: { id: item.message_link_content },
        });
      } else if (item.message_link_type == 3) {
        this.$router.push({
          name: 'NewsShow',
          params: { id: item.message_link_content },
        });
      } else if (item.message_link_type == 5) {
        this.$router.push({
          name: 'LibraryDetail',
          params: { id: item.message_link_content },
        });
      } else {
        window.open(item.message_link_content);
      }
    },
    async setRead() {
      await this.$promiseConfirm('确认要全部标为已读吗？', { type: 'warning' });
      await this.$http.post('/api/app/message/mark/read');
      this.list.forEach((item) => {
        item.is_read = 1;
      });
      this.$store.commit('setAllMessageRead');
    },
  },
};
</script>
<style lang="scss" scoped>
.MemberMessage {
  top: -8px;
  position: relative;
  background: #fff;
  padding: 0 24px;
}
.el-tabs-common {
  padding: 2px 0 0 0;
}

.tab-content {
  padding: 0 0 24px 0;
  background-color: white;
}

.item {
  position: relative;
  display: flex;
  padding: 24px;
  border-bottom: 1px solid #f3f3f3;
  align-items: center;
  justify-content: center;
  gap: 20px;
  overflow: hidden;

  &:first-child {
    padding-top: 16px;
  }
  &:hover {
    box-shadow: 0px 3px 15px 0px rgba(224, 224, 224, 1);
  }

  .left {
    flex: 1;
    .title-wrap {
      display: flex;
      align-items: center;
      justify-content: start;
      .icon {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
      .title {
        position: relative;
        color: #1a1a1a;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        &.noRead {
          &::after {
            content: '';
            display: block;
            position: absolute;
            width: 8px;
            height: 8px;
            background-color: #ff2d4d;
            border-radius: 50%;
            left: -16px;
            top: 0;
          }
          &:first-child::after {
            left: initial;
            right: -4px;
          }
        }
      }
    }
    .content {
      margin-top: 14px;
      word-break: break-all;
      color: #1a1a1a;
      font-size: 14px;
      line-height: normal;
    }

    .content-expand {
      text-decoration: none;
      height: 20px;
      font-size: 14px;
      color: $primary-color;
      line-height: 20px;
      img {
        width: 16px;
        vertical-align: -2px;
      }
    }

    .link-wrap {
      margin-top: 12px;
      img {
        width: 14px;
        margin-right: 5px;
        vertical-align: -2px;
      }
      a {
        height: 20px;
        font-size: 14px;
        color: $primary-color;
        line-height: 20px;
        text-decoration: none;
      }
    }
    .created-time {
      margin-top: 8px;
      color: #666;
      font-size: 14px;
    }
  }
  .right {
    width: 104px !important;
    display: flex;
    padding: 9px 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 30px;
    background: linear-gradient(91deg, #ff5858 11.16%, #ff6b00 60.83%, #ff3743 102.99%);
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);
    color: #fff;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
}

.pager {
  margin: 0;
  padding-bottom: 24px !important;
}

.read-wrap {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  height: 62px;
  right: 24px;
  cursor: pointer;
  img {
    width: 21px;
    margin-right: 6px;
  }
  span {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: $primary-color;
  }
}
</style>
<style lang="scss">
@import '@/assets/css/varibles.scss';

.message a {
  color: $primary-color;
  cursor: pointer;
  text-decoration: underline;
}
</style>
